export default __webpack_public_path__ + "static/media/sql.8af92b99.png";